import { useUserContext } from '@app/util/hooks/useUserContext'
import type { ContactDetailsFormValues } from '@app/pages/dashboard/initiative/shared/validation/initiativeValidation'
import { type ReactNode, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

/** Prefills empty name/email from the signed-in user (onboarding only). */
export const ContactDetailsUserPrefillFromProfile = (): ReactNode => {
  const { user } = useUserContext()
  const { getValues, setValue } = useFormContext<ContactDetailsFormValues>()

  useEffect(() => {
    if (!user) {
      return
    }
    const v = getValues()
    if ((v.contactFirstName ?? '').trim() === '') {
      setValue('contactFirstName', user.firstName ?? '', {
        shouldValidate: true,
      })
    }
    if ((v.contactLastName ?? '').trim() === '') {
      setValue('contactLastName', user.lastName ?? '', {
        shouldValidate: true,
      })
    }
    if ((v.contactEmail ?? '').trim() === '') {
      setValue('contactEmail', user.email ?? '', { shouldValidate: true })
    }
  }, [user, getValues, setValue])

  return null
}
